export default __webpack_public_path__ + "assets/04ba075dfcc34522ceaa3000ffcdf64e.png";